<!--<ng-container *ngIf="layout === 'vertical'">
  <app-header-vertical></app-header-vertical>
</ng-container>

<ng-container *ngIf="layout === 'horizontal'" (window:resize)="onResize($event)">
  <app-header-horizontal></app-header-horizontal>
</ng-container>
<ngx-spinner type="ball-scale-multiple">
  <div class="ball-pulse-sync">
    <div></div>
    <div></div>
    <div></div>
  </div>
</ngx-spinner>-->
<!--<header class="header">
  <button class="sidebar-toggle" (click)="onToggleSidebar()">☰</button>

  <div class="header-title">Billing Dashboard</div>

  <div class="header-search">
    <span>🔍</span>
    <span>Search transactions, orders…</span>
  </div>

  <div class="header-actions">
     Dark mode toggle
    <div class="theme-row">
      <span>☀️</span>
      <div class="theme-toggle" [class.dark]="isDark" (click)="onToggleTheme()">
        <div class="theme-toggle-thumb">{{ isDark ? '🌙' : '☀️' }}</div>
      </div>
      <span>🌙</span>
    </div>

    <div class="header-btn" (click)="onNotification()">
      🔔
      <span class="notif-dot"></span>
    </div>

    <div class="header-btn" (click)="onCart()">
      🛒
    </div>

    <div class="user-pill">
      <div class="user-avatar">R</div>
      <span class="user-name">Raghu</span>
    </div>
  </div>
</header>-->
<!--<header class="header">
  <button type="button"
          class="sidebar-toggle"
          (click)="toggleSidebar()"
          [attr.aria-expanded]="sidebarOpen"
          aria-label="Toggle navigation">
    ☰
  </button>
  <div class="header-title">Billing Dashboard</div>

  <div class="header-search" role="search">
    <span aria-hidden="true">🔍</span>
    <span>Search transactions, orders…</span>
  </div>

  <div class="header-actions">
    <div class="theme-toggle-wrap">
      <span class="theme-label" aria-hidden="true">☀️</span>
      <button type="button"
              class="theme-toggle"
              [class.dark]="isDarkMode"
              (click)="toggleTheme()"
              [attr.aria-label]="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'">
        <span class="theme-toggle-thumb">{{ isDarkMode ? '🌙' : '☀️' }}</span>
      </button>
      <span class="theme-label" aria-hidden="true">🌙</span>
    </div>

    <button type="button" class="header-btn"
            (click)="showToast('Notifications', '3 new alerts.')"
            aria-label="Notifications">
      🔔
      <span class="notif-dot"></span>
    </button>
    <button type="button" class="header-btn"
            (click)="showToast('Cart', '2 pending orders.')"
            aria-label="Cart">
      🛒
    </button>
    <button type="button" class="user-pill"
            (click)="showToast(userName, 'Account menu opened.')"
            aria-label="Account menu">
      <span class="user-avatar">{{ userInitial }}</span>
      <span class="user-name">{{ userName }}</span>
    </button>
  </div>
</header>-->
<!--<header class="header">

  <button type="button"
          class="sidebar-toggle"
          (click)="toggleSidebar()"
          aria-label="Toggle navigation">
    ☰
  </button>-->
<!--{{ pageTitle }}-->
<!--<div class="header-title"></div>

<div class="header-search" role="search">
  <span aria-hidden="true">🔍</span>
  <span>{{ searchPlaceholder }}</span>
</div>

<div class="header-actions">

  <div class="theme-toggle-wrap">
    <span class="theme-label" aria-hidden="true">☀️</span>
    <button type="button"
            class="theme-toggle"
            [class.dark]="isDarkMode"
            (click)="toggleTheme()"
            [attr.aria-label]="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'">
      <span class="theme-toggle-thumb">{{ isDarkMode ? '🌙' : '☀️' }}</span>
    </button>
    <span class="theme-label" aria-hidden="true">🌙</span>
  </div>-->
<!--<div class="header-icon">
  <button class="bell-button" [ngStyle]="styles.bellButton.root" (click)="toggleNotifications()">
    <svg [ngStyle]="styles.bellButton.root.svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 2C10.34 2 9 3.34 9 5v2H7c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2v1h10v-1c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-2V5c0-1.66-1.34-3-3-3zm0 2c.552 0 1 .448 1 1v2H11V5c0-.552.448-1 1-1zm-6 6V9h12v1H6zm6 8c-1.66 0-3-1.34-3-3h6c0 1.66-1.34 3-3 3zm0-2h-.01H12z" />
    </svg>
    <div class="notification-dot" [ngStyle]="styles.bellButton.dot">
      <rect [ngStyle]="styles.bellButton.dot.rect"></rect>
    </div>
    <span class="button__badge">{{count}}</span>
  </button>-->
<!--<div *ngIf="showNotifications">-->
<!--<button type="button" class="header-btn"
        (click)="onBellClick()">


  🔔
  <p *ngFor="let notification of Notificationlist">{{ notification.message }}</p>
  <span *ngIf="count > 0" class="notif-dot"></span>-->
<!--<span class="notif-dot">{{count}}</span>-->
<!--</button>-->
<!--</div>-->
<!--</div>-->
<!--<button type="button" class="header-btn"
              (click)="onCartClick()"
              aria-label="Cart">
        🛒
      </button>
      <div class="dropdown-user nav-item" ngbDropdown>
        <a class="user-pill" ngbDropdownToggle aria-label="Account menu">
          <span class="user-avatar">{{ userInitial }}</span>
          <span class="user-name">{{ userName }}</span>
        </a>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownProfileMenu">
          <a class="dropdown-item" [routerLink]="['/user/user-profile']">
            <i class="feather ft-user"></i> Edit Profile
          </a>
          <a class="dropdown-item" (click)="ResetPasswordPage()">
            <i class="la la-key"></i> Reset Password
          </a>
          <a class="dropdown-item" [routerLink]="'/login'">
            <i class="feather ft-power"></i> Logout
          </a>
        </div>
      </div>
    </div>
</header>-->




<nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-shadow">
  <div class="navbar-wrapper">
    <div class="navbar-header">
      <ul class="nav navbar-nav flex-row">
        <li class="nav-item mobile-menu d-lg-none mr-auto">
          <a class="nav-link nav-menu-main menu-toggle hidden-xs11" (click)="toggleSidebar()">
            <i class="feather ft-menu font-large-1"></i>
          </a>
        </li>
        <li class="nav-item mr-auto">
          <a class="navbar-brand">
            <img class="brand-logo" alt="branding logo" [src]="companyLogoUrl">
            <h3 class="brand-text">{{ companyName }}</h3>
          </a>
        </li>
        <li class="nav-item d-none d-md-block nav-toggle">
          <a class="nav-link modern-nav-toggle pr-0" (click)="toggleSidebar()">
            <i class="feather ft-toggle-left font-medium-3 white"></i>
          </a>
        </li>
      </ul>
    </div>

    <div class="navbar-container content">
      <div class="collapse navbar-collapse show">
        <ul class="nav navbar-nav mr-auto float-left">
          <li class="nav-item nav-search">
            <a class="nav-link nav-link-search">
              <i class="ficon feather ft-search"></i>
            </a>
            <div class="search-input">
              <input class="input" type="text" [placeholder]="searchPlaceholder">
            </div>
          </li>
        </ul>
        <ul class="nav navbar-nav float-right">

          <!-- Notification Dropdown -->
          <li class="dropdown-notification nav-item" ngbDropdown>
            <a class="nav-link nav-link-label" ngbDropdownToggle (click)="onBellClick()">
              <i class="ficon feather ft-bell"></i>
              <span *ngIf="count > 0" class="badge badge-pill badge-danger notification-badge">{{ count }}</span>
            </a>
            <ul class="dropdown-menu-media dropdown-menu-right" ngbDropdownMenu>
              <li class="dropdown-menu-header">
                <h6 class="dropdown-header m-0"><span class="grey darken-2">Notifications</span></h6>
              </li>
              <li class="scrollable-container media-list w-100">
                <p *ngFor="let notification of Notificationlist" class="notification-text px-2 py-1">{{ notification.message }}</p>
              </li>
            </ul>
          </li>

          <!-- User Dropdown -->
          <li class="dropdown-user nav-item" ngbDropdown>
            <a class="nav-link dropdown-user-link" ngbDropdownToggle>
              <span>{{ userName }}</span>
              <span class="avatar avatar-online">
                <!--<span class="user-avatar-initial">{{ userInitial }}</span>
                <i></i>-->
              </span>
            </a>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownProfileMenu">
              <a class="dropdown-item" [routerLink]="['/user/user-profile']">
                <i class="feather ft-user"></i> Edit Profile
              </a>
              <a class="dropdown-item" (click)="ResetPasswordPage()">
                <i class="la la-key"></i> Reset Password
              </a>
              <a class="dropdown-item" [routerLink]="'/login'">
                <i class="feather ft-power"></i> Logout
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>


